/* iOrganic header: hide on scroll-down, show on scroll-up after 200px.
   Adds .io-scrolled (solid bg) and .io-header-hidden (translated off) to
   the header section wrapper. CSS lives in iorganic-tokens.css. */
(function () {
  var wrapper =
    document.querySelector('.section-header') ||
    (document.querySelector('header.header') &&
      document.querySelector('header.header').closest('.shopify-section')) ||
    document.querySelector('header.header');
  if (!wrapper) return;

  var THRESHOLD = 200;
  var lastY = window.scrollY || 0;
  var ticking = false;

  function update() {
    var y = window.scrollY || 0;
    if (y > THRESHOLD) {
      wrapper.classList.add('io-scrolled');
      if (y > lastY + 4) {
        wrapper.classList.add('io-header-hidden');
      } else if (y < lastY - 4) {
        wrapper.classList.remove('io-header-hidden');
      }
    } else {
      wrapper.classList.remove('io-scrolled');
      wrapper.classList.remove('io-header-hidden');
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
